if (!customElements.get('sv-hero')) {
  customElements.define('sv-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-sv-hero-slide]')];
      this.index = 0; this.request = 0; this.hovered = false;
      this.visibilityObserver?.disconnect(); this.visible = !('IntersectionObserver' in window);
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
        this.visibilityObserver.observe(this);
      }
      this.querySelectorAll('[data-sv-hero-control]').forEach(el => { el.hidden = false; });
      this.querySelector('[data-sv-hero-prev]')?.addEventListener('click', () => this.manual(-1), opts);
      this.querySelector('[data-sv-hero-next]')?.addEventListener('click', () => this.manual(1), opts);
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, opts);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, opts);
      this.addEventListener('focusin', () => this.sync(), opts);
      this.addEventListener('focusout', () => queueMicrotask(() => this.isConnected && this.sync()), opts);
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.manual(e.key === 'ArrowLeft' ? -1 : 1); }
      }, opts);
      let touchX = null;
      this.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { ...opts, passive: true });
      this.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - touchX;
        if (touchX !== null && Math.abs(dx) > 60) this.manual(dx < 0 ? 1 : -1);
        touchX = null;
      }, { ...opts, passive: true });
      document.addEventListener('sv:motionchange', () => this.sync(), opts);
      document.addEventListener('visibilitychange', () => this.sync(), opts);
      this.addEventListener('shopify:block:select', e => {
        const i = this.slides.findIndex(slide => slide === e.target || slide.contains(e.target));
        if (i >= 0) { this.editorPaused = true; this.show(i); this.sync(); }
      }, opts);
      this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.sync(); }, opts);
      this.preloadTimer = setTimeout(() => this.prepare(1), 1200);
      this.sync();
    }
    disconnectedCallback() { clearInterval(this.timer); clearTimeout(this.preloadTimer); this.request++; this.abort?.abort(); this.visibilityObserver?.disconnect(); }
    manual(step) { this.show(this.index + step); this.sync(); }
    async prepare(index) {
      const slide = this.slides[(index + this.slides.length) % this.slides.length];
      if (!slide) return false;
      const template = slide.querySelector('template');
      if (template) template.replaceWith(template.content.cloneNode(true));
      const img = slide.querySelector('img');
      try { await img?.decode(); } catch { return false; }
      return Boolean(img?.naturalWidth);
    }
    async show(index) {
      if (!this.slides.length) return;
      const next = (index + this.slides.length) % this.slides.length;
      const request = ++this.request;
      if (!await this.prepare(next) || request !== this.request || !this.isConnected) return;
      this.index = next;
      this.slides.forEach((slide, i) => {
        const active = i === next;
        slide.classList.toggle('is-active', active); slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.prepare(next + 1);
    }
    sync() {
      clearInterval(this.timer);
      const run = this.visible && !window.svMotion?.stopped() && !document.hidden && !this.hovered && !this.contains(document.activeElement) && !this.editorPaused;
      this.dataset.running = String(run);
      if (run && this.slides.length > 1) this.timer = setInterval(() => this.show(this.index + 1), 3000);
    }
  });
}
